import { useContext } from "@nuxtjs/composition-api";
import { Kind } from "graphql/language";
import { selectDataTableFields } from "~/components/_refactored/conductor/data-table/selectDataTableFields";

const reportedSelections = new WeakSet();

function rootFieldKey(document) {
  const operation = document.definitions.find(
    (definition) => definition.kind === Kind.OPERATION_DEFINITION
  );
  const rootField = operation.selectionSet.selections.find(
    (selection) => selection.kind === Kind.FIELD
  );
  return rootField.alias?.value ?? rootField.name.value;
}

function selectFields(document, fields) {
  const selection = selectDataTableFields(document, fields);
  if (
    process.env.NODE_ENV !== "production" &&
    selection.unmatchedFields.length &&
    !reportedSelections.has(selection)
  ) {
    reportedSelections.add(selection);
    console.warn(
      `[${rootFieldKey(document)}] column fields not found in the query:`,
      selection.unmatchedFields
    );
  }
  return selection.document;
}

export function useDataTableQuery(
  importDocument,
  { queryOptions, mapItem } = {}
) {
  const { $query } = useContext();

  return async function load(variables, { fields } = {}) {
    try {
      const module = await importDocument();
      const document = module.default || module;
      const data = await $query(
        fields ? selectFields(document, fields) : document,
        variables,
        queryOptions
      );
      const result = data[rootFieldKey(document)];
      return mapItem ? { ...result, items: result.items.map(mapItem) } : result;
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  };
}
